import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faTrash as faTrashSolid } from '@fortawesome/pro-solid-svg-icons';
import { IIepePortSettingsTemplateResponse } from '@kcftech/prometheustypescriptapiclient';
import { useMutation } from '@tanstack/react-query';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { useNotificationContext } from 'contexts/NotificationContext';
import { sdClient } from 'contexts/SDKClientContext';
import { useState } from 'react';
import { tokens } from 'styles/tokens';

export type DeleteTemplateCellProps = Readonly<{
    rowData: IIepePortSettingsTemplateResponse;
    onChange: () => void;
    locationId: string;
}>;

export function DeleteTemplateCell({ rowData, onChange }: DeleteTemplateCellProps) {
    const { showToast } = useNotificationContext();
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const { mutate: deleteTemplate, isPending: isDeleting } = useMutation({
        mutationFn: () =>
            sdClient.deleteIepePortSettingsTemplate({
                nodeSettingsTemplateId: rowData.Id,
            }),

        onSuccess: () => {
            onChange();
            setConfirmModalOpen(false);
            showToast({
                type: 'success',
                content: 'Successfully deleted template',
            });
        },

        onError: () => {
            showToast({
                type: 'error',
                content: 'Failed to delete template',
            });
        },
    });

    return (
        <div className="flex-row align-center flex-nowrap f-16">
            <HoverIconButton
                icon={faTrash}
                hoverIcon={faTrashSolid}
                color={tokens.text.secondary}
                hoverColor={tokens.error.default}
                onClick={() => setConfirmModalOpen(true)}
            />
            {confirmModalOpen && (
                <ConfirmModal
                    title={`Delete Template ${rowData.Name}`}
                    actionText="delete this template?"
                    checkText="delete this template"
                    closable={!isDeleting}
                    actionable={!isDeleting}
                    actionButtonText="Delete"
                    onAction={deleteTemplate}
                    onClose={() => setConfirmModalOpen(false)}
                />
            )}
        </div>
    );
}
